import { OrganizationalImpactWebComponent } from './component/OrganizationalImpactWebComponent';
import { WEB_COMPONENT_ORGANIZATIONAL_IMPACT } from '../../webcomponents.constants';

export { OrganizationalImpactWebComponent };

window.customElements.define(WEB_COMPONENT_ORGANIZATIONAL_IMPACT, OrganizationalImpactWebComponent);
